import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';
import { EndpageHeaderProps } from '.';

type StyleProps = Required<Pick<EndpageHeaderProps, 'headerColor' | 'hasLogo'>>;

const useStyles = createUseStyles(({ type, elevation, brandColors, breakpoints, spacing }: CmsWrenchTheme) => ({
  '@keyframes notice': {
    '20%': {
      top: 0,
    },
    '80%': {
      top: 0,
    },
  },
  header: ({ headerColor, hasLogo }: StyleProps) => ({
    zIndex: elevation.sky,
    color: brandColors.neutral.white,
    backgroundColor: brandColors.primary[headerColor],
    flexDirection: hasLogo ? 'column' : 'row',
    [`@media (max-width: ${breakpoints.md}px)`]: {
      flexDirection: 'column',
    },
  }),
  thanks: {
    position: 'absolute',
    top: '-500px',
    boxSizing: 'border-box',
    width: '100%',
    animationName: '$notice',
    animationDuration: '7s',
    animationDelay: '2s',
  },
  icon: {
    fontSize: type.fontSize.pageTitle,
    color: brandColors.neutral.white,
    marginRight: spacing[2],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      stroke: brandColors.neutral.white,
      strokeWidth: 0.5,
      overflow: 'visible',
    },
  },
  logo: {
    fontSize: (type.fontSize.pageTitle as number) + 6,
    marginBottom: spacing[3],
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom: spacing[1],
    },
  },
  copy: {
    color: brandColors.neutral.white,
    fontWeight: 500,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      fontSize: type.fontSize.sectionTitle,
    },
  },
}));
export default useStyles;
